import {Component, OnInit} from '@angular/core';
import {ResourcePageState} from '../../services/resource-page-state.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  providers: [ResourcePageState],
})
export class ErrorComponent implements OnInit {
  constructor(public readonly resourcePage: ResourcePageState) {}
  ngOnInit(): void { this.resourcePage.show('500'); }
}
